import { useEffect, useState, type ReactNode } from "react";
import { ModelCatalogContext } from "./ModelCatalogContext";
import type { Model } from "@lumen/shared";
import { api } from "./api";
import { createModelCatalog } from "./modelCatalog";
import { subscribeToDataChanges } from "./components/projects/projectEvents";

export function ModelCatalogProvider({ children }: { children: ReactNode }) {
  const [catalog] = useState(() =>
    createModelCatalog(() => api<Model[]>("/models")),
  );
  useEffect(
    () => subscribeToDataChanges(() => catalog.invalidate()),
    [catalog],
  );
  return (
    <ModelCatalogContext.Provider value={catalog}>
      {children}
    </ModelCatalogContext.Provider>
  );
}
